;(function() {
  'use strict'

  Controller.$inject = ["userService", "glDialog", "questionLicenseService"];
  angular.module('app.core').component('viewPicker', {
    controller: Controller,
    templateUrl: 'view-picker.html',
    bindings: {
      title: '@',
      singleTab: '<',
      isQuestionOnly: '<',
      isSurveyTemplate: '<',
      onSelect: '&',
      onCancel: '&',
    },
  })

  var lastTab = 'new'

  /* @ngInject */
  function Controller(userService, glDialog, questionLicenseService) {
    var ctrl = this

    ctrl.licenseContactHref = questionLicenseService.contactHref
    ctrl.selectView = selectView
    ctrl.selectQuestionTemplate = selectQuestionTemplate
    ctrl.selectViews = selectViews
    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy

    function onInit() {
      if (!ctrl.singleTab) {
        ctrl.tabs = [
          { label: 'New', value: 'new' },
          { label: 'Import from', value: 'import-from' },
          { label: 'Question library', value: 'library' },
          {
            label: 'Omni import',
            value: 'omni-import',
            hidden: !userService.isSSR(),
          },
        ]
        ctrl.tab = lastTab
      } else {
        ctrl.tab = ctrl.singleTab
      }
    }

    function selectView(item) {
      if (item.license && !item.license.isLicensed) {
        return glDialog
          .confirm(
            'GMS license required',
            [
              'Your organisation does not have an active GMS license for ',
              item.license.label,
              '. You can add this question, but the survey cannot be saved ',
              'until it is removed. ',
              '<a href="',
              ctrl.licenseContactHref,
              '" target="_blank">Contact Glow</a> to arrange access.',
            ].join(''),
            {
              locals: {
                closeText: 'Add anyway',
                cancelText: 'Cancel',
              },
            }
          )
          .then(function() {
            doSelectView(item)
          })
      }

      doSelectView(item)
    }

    function doSelectView(item) {
      if (item.type) {
        ctrl.onSelect({
          $response: {
            type: 'question-type',
            value: item.type,
            defaults: item.defaults,
          },
        })
      } else {
        ctrl.onSelect({
          $response: {
            type: 'section',
          },
        })
      }
    }

    function selectQuestionTemplate(template) {
      ctrl.onSelect({
        $response: {
          type: 'question-template',
          value: template,
        },
      })
    }

    function selectViews(views, viewGroups, shuffleGroups) {
      ctrl.onSelect({
        $response: {
          type: 'views',
          value: {
            views: views,
            viewGroups: viewGroups,
            shuffleGroups: shuffleGroups,
          },
        },
      })
    }

    function onDestroy() {
      lastTab = ctrl.tab
    }
  }
})()
